import { ListPageSkeleton } from '@practium/ui';

export const PropertiesPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={3}
		sidebarWidth="28rem"
		sidebarW1500="24rem"
		sidebarW1300="20rem"
		sidebarW1200="18rem"
		stackAt={1100}
	/>
);
